import { render, staticRenderFns } from "./history.vue?vue&type=template&id=4e1a7c58&scoped=true&lang=pug&"
import script from "./history.vue?vue&type=script&setup=true&lang=js&"
export * from "./history.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&id=4e1a7c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a7c58",
  null
  
)

export default component.exports